import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import DownloadImage from "../../../assets/images/download.svg";
import Edit from "../../../assets/images/ic-edit.svg";
import DeleteBox from "../../../assets/images/ic-deletebox.svg";
import { formatDate } from "../../../constant/DateFormat";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  GetUserPermisionData,
  selectUserPermisionData,
} from "../../../features/rolebase/userPermissionSlice";
import { engPdfUrl, policyPdfAPi } from "../../../features/network/ApiCall";
import { isPermited } from "../../../features/localStorage";
import { truncateText } from "../../../constant/TruncateText";
const PolicyItem = ({
  item,
  GetUserPermision,
  handleEdit,
  handleDelete,
}: {
  item: any;
  GetUserPermision: any;
  handleEdit: any;
  handleDelete: any;
}) => {
  const history = useHistory();
  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const policySourceType = JSON.parse(userDetailsList);
  const handleClick = () => {
    history.push({
      pathname: `/policy-details/${item.policyId}`,
      state: { data: item },
    });
    // history.push(`/policy-details/${item.policyId}`);
  };
  // const dispatch = useAppDispatch();
  // const UserPermision = useAppSelector(selectUserPermisionData);
  useEffect(() => {
    // async function fetchUserPermission() {
    //   let sample = await dispatch(GetUserPermisionData());
    // }
    // fetchUserPermission();
  }, []);
  return (
    <div style={{ paddingLeft: '1rem', paddingRight: '1rem' }}>
      <Row className='px-4 py-1 bottom_line'>
        <Col lg={2} md={2} sm={2} style={styles.data} onClick={handleClick}>
          {item.policyName}
        </Col>
        <Col lg={4} md={4} sm={4} style={styles.data} onClick={handleClick}>
          {' '}
          {item?.objectives ? truncateText(item?.objectives, 70) : '-'}
        </Col>
        <Col lg={2} md={2} sm={2} style={styles.data} onClick={handleClick}>
          {' '}
          {item?.effectiveDate ? formatDate('' + item?.effectiveDate) : '-'}
        </Col>
        {GetUserPermision?.roleId === 1 || GetUserPermision === 5 ? (
          <Col lg={2} md={2} sm={2} style={styles.data} onClick={handleClick}>
            {item?.updatedDate ? formatDate('' + item?.updatedDate) : '-'}
          </Col>
        ) : null}
        <Col lg={1} md={1} sm={1}>
          {policySourceType?.mahindraCompanyList?.policySource === true ? (
            <a
              href={`${engPdfUrl}${item.policy_pdf_link}`}
              rel='noopener noreferrer'
              target='_blank'
            >
              <img src={DownloadImage} />
            </a>
          ) : (
            <a
              href={`${policyPdfAPi}${item.policy_pdf_link}`}
              rel='noopener noreferrer'
              target='_blank'
            >
              <img src={DownloadImage} />
            </a>
          )}
        </Col>
        {policySourceType?.mahindraCompanyList?.policySource === true ? (
          <Col lg={1} md={1} sm={1}>
            {isPermited(11, 3) && (
              <a onClick={() => handleEdit(item)}>
                <img src={Edit} />
              </a>
            )}
            {isPermited(11, 4) && (
              <a
                onClick={() => handleDelete(item)}
                style={{ marginLeft: '10px' }}
              >
                <img src={DeleteBox} />
              </a>
            )}
          </Col>
        ) : null}
      </Row>
    </div>
  );
};

const styles: any = {
  data: {
    fontFamily: "Saira",
    fontSize: "14px",
    fontWeight: "500",
    paddingTop: "5px",
  },
};

export default PolicyItem;
